import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Trophy, CreditCard, ArrowRight } from "lucide-react";

export const QuickLinksSection = () => {
  return (
    <section className="py-16 bg-white" data-testid="quick-links-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Competitions Card */}
          <Link to="/competitions">
            <Card className="group hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-purple-500/20 rounded-3xl overflow-hidden cursor-pointer h-full" data-testid="competitions-link-card">
              <CardHeader className="bg-gradient-to-br from-purple-500/5 to-purple-500/10 p-8">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 bg-purple-500/20 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform">
                    <Trophy className="w-8 h-8 text-purple-600" />
                  </div>
                  <div>
                    <CardTitle className="text-2xl text-slate-800">Competitions</CardTitle>
                    <CardDescription className="text-base text-slate-600">
                      Participate in reels, singing & creative contests
                    </CardDescription>
                  </div>
                </div>
              </CardHeader>
              <CardContent className="p-6">
                <div className="flex items-center text-purple-600 font-medium">
                  View Competitions <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-2 transition-transform" />
                </div>
              </CardContent>
            </Card>
          </Link>
          
          {/* Payment/Donation Card */}
          <Link to="/payment">
            <Card className="group hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-green-500/20 rounded-3xl overflow-hidden cursor-pointer h-full" data-testid="payment-link-card">
              <CardHeader className="bg-gradient-to-br from-green-500/5 to-green-500/10 p-8">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 bg-green-500/20 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform">
                    <CreditCard className="w-8 h-8 text-green-600" />
                  </div>
                  <div>
                    <CardTitle className="text-2xl text-slate-800">Donate & Support</CardTitle>
                    <CardDescription className="text-base text-slate-600">
                      Make a payment or donation to support our cause
                    </CardDescription>
                  </div>
                </div>
              </CardHeader>
              <CardContent className="p-6">
                <div className="flex items-center text-green-600 font-medium">
                  Make a Donation <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-2 transition-transform" />
                </div>
              </CardContent>
            </Card>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default QuickLinksSection;
